// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-field__error-space-preserver {
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/TextField/TextField.css","webpack://./services/frontend/app/components/TextField/TextField.css"],"names":[],"mappings":"AADA;ECEE,YAAY;AACd","sourcesContent":[".text-field__error-space-preserver {\n  height: 18px;\n}\n",".text-field__error-space-preserver {\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
